import { reportAccumulatedDiscountTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_ACCUMULATED_DISCOUNT_FILTERS,
  RESTORE_INITIAL
} = reportAccumulatedDiscountTypes;

const initialState = {
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportAccumulatedDiscountReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ACCUMULATED_DISCOUNT_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return initialState;

    default:
      return state;
  }
};
